const createTotals = (order, tax, t, formatCurrency, language) => {
  
  
  // Get tax rate
  const taxRate = parseFloat(tax.percentage || 15) / 100; // Default to 15% if not specified
  
  // Check if this is a return receipt or a regular receipt
  const isCardOrder = order.isCardOrder || false;
  const isReturnReceipt = order.is_return === true || order.return_id || false;
  
  
  // Calculate totals from items if available
  let subtotalWithTax = 0;
  
  if (order.items && order.items.length > 0) {
    // Calculate the sum of all items
    subtotalWithTax = order.items.reduce((total, item) => {
      const quantity = parseFloat(item.quantity) || 1;
      let unitPrice = parseFloat(item.unit_price) || 0;
      
      // If unit_price is not available, try to calculate from price
      if (unitPrice === 0 && item.price) {
        unitPrice = parseFloat(item.price) / quantity;
      }
      
      // Only make unit price negative for return receipts
      if (isReturnReceipt && unitPrice > 0) {
        unitPrice = -unitPrice;
      }
      
      // Calculate row total
      const rowTotal = unitPrice * quantity;
      
      return total + rowTotal;
    }, 0);
    
  } else if (order.total) {
    // If no items, use the order total
    subtotalWithTax = parseFloat(order.total);
    // Only make total negative for return receipts
    if (isReturnReceipt && subtotalWithTax > 0) {
      subtotalWithTax = -subtotalWithTax;
    }
  }
  
  // Calculate delivery fee (if any)
  let deliveryFee = parseFloat(order.delivery_fee || 0);
  // Only make delivery fee negative for return receipts
  if (isReturnReceipt && deliveryFee > 0) {
    deliveryFee = -deliveryFee;
  }
  
  // Calculate subtotal before tax by dividing total by (1 + tax rate)
  const subtotalBeforeTax = subtotalWithTax / (1 + taxRate);
  
  // Tax amount is the difference between total and subtotal
  const taxComponent = subtotalWithTax - subtotalBeforeTax;
  
  // Round all values to 2 decimal places, preserving negative signs
  const finalSubtotal = Math.round(subtotalBeforeTax * 100) / 100;
  const finalTax = Math.round(taxComponent * 100) / 100;
  const finalTotal = Math.round(subtotalWithTax * 100) / 100;
  
  // Set the adjusted values to use in the template
  const adjustedSubtotal = finalSubtotal;
  const adjustedTax = finalTax;
  const adjustedTotal = finalTotal;
  

  return `
    <div style="
      margin: 3mm 0;
      font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif;
      text-align: ${language === 'ar' ? 'right' : 'left'};
    ">
      <div style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1mm 0;
      ">
        <div style="color: #444;">${language === 'ar' ? 
            `<span style="
              font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif;
              direction: rtl;
              unicode-bidi: bidi-override;
              white-space: nowrap;
              letter-spacing: 0;
              display: inline-block;
            ">${t('cashier.receipt.totals.subtotal')}</span>` : 
            t('cashier.receipt.totals.subtotal')}</div>
        <div>${formatCurrency(adjustedSubtotal)}</div>
      </div>

      ${order.tax > 0 ? `
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1mm 0;
          color: #444;
        ">
          <div>${language === 'ar' ? 
              `<span style="
                font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif;
                direction: rtl;
                unicode-bidi: bidi-override;
                white-space: nowrap;
                display: inline-block;
              ">${t('cashier.receipt.totals.tax')} (<span style="direction: ltr; display: inline-block;">${tax.percentage}%</span>)</span>` : 
              t('cashier.receipt.totals.tax') + ' (' + tax.percentage + '%)'}</div>
          <div>${formatCurrency(adjustedTax)}</div>
        </div>
      ` : ''}

      ${order.delivery_fee > 0 ? `
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1mm 0;
          color: #444;
        ">
          <div>${language === 'ar' ? t('cashier.receipt.totals.deliveryFee') : t('cashier.receipt.totals.deliveryFee')}</div>
          <div>${formatCurrency(deliveryFee)}</div>
        </div>
      ` : ''}

      <div style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2mm 0;
        margin-top: 1mm;
        border-top: 1px solid #000;
        font-weight: bold;
        font-size: 9pt;
      ">
        <div>${language === 'ar' ? 
            `<span style="
              font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif;
              direction: rtl;
              unicode-bidi: bidi-override;
              white-space: nowrap;
              letter-spacing: 0;
              display: inline-block;
              font-weight: bold;
            ">${t('cashier.receipt.totals.total')}</span>` : 
            t('cashier.receipt.totals.total')}</div>
        <div>${formatCurrency(adjustedTotal)}</div>
      </div>
      
      <!-- Removing the includingTax line since it's showing incorrectly -->
    </div>
  `;
};


export default createTotals;
